export default "__VITE_ASSET__7iiTidmy__"